import React, { Component } from 'react';
import Modal from 'react-modal';
import { Link } from 'gatsby';

import './Layout';

class PortfolioItem extends Component {
    constructor(props) {
        super(props)
        this.src = require('../assets/images/unveiled.gif');
        this.desc = 'VR Archery Adventure';
        this.title =  'Unveiled';
        this.i = 'A';
        this.roles = 'Programming and design';
        this.state = {
          isModalOpen: false,
        }
      }
      handleModalOpen = event => {
        // console.log('handleModalOpen: ', event);
        this.setState({ isModalOpen: true })
      }
    
      handleModalClose = event => {
        // console.log('handleModalOpen: ', event);
        this.setState({ isModalOpen: false })
      }

      updateObject = (obj) => {
        if(obj == null)
            return;

        this.src = obj.src;
        this.desc = obj.desc;
        this.title = obj.title;
        this.i = obj.info;
        this.roles = obj.roles;
      }

    renderItems(){
        const { images } = this.props;

        if (!images) return;

        const portfolioitem = images.map((obj, i) => {
        return(   
            <div className="col-lg-4 col-sm-6">             
            <section className="tiles">
                    <article className="style1">
                        <span className="image">
                            <img src={obj.src} alt="" /> 
                        </span>
                            <Link to="#" onClick={() => {this.handleModalOpen(); this.updateObject(obj);}}>
                                <div className="content">
                                    <p> 
                                        {obj.desc}
                                    </p>
                                </div>
                            </Link>
                        <h3>{obj.title}</h3>

                    <Modal
                        isOpen={this.state.isModalOpen}
                        className="Modal"
                        onRequestClose={this.handleModalClose}
                        contentLabel={this.title}
                        >

                        <div className="modalcontent"> 
                            <h2>{this.title}</h2>
                            <img src={this.src} alt =""/>
                            <h3>Description:</h3>
                            <p>{this.i}</p>
                            <h3>Role:</h3>
                            <p>{this.roles}</p>

                        <br />
                        <br />
                        <br />
                        <button onClick={this.handleModalClose}>Close</button>
                        </div>
                    </Modal>  
                    </article>
                </section>
                </div>  
        );
        });

        return (
            <div className="w-100">
                <h2 className="mb-5">Portfolio</h2>  
                <div className="container-fluid p-0">
                    <div className="row"> {portfolioitem} </div>
                </div>
            </div>
        );
    }

    render(){
        return(
            <>
                {this.renderItems()}
            </>
        );
    }

}

export default PortfolioItem;